// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"610":"e929f20d8d6f0c2498e7","630":"4f1b45fdbf104ba13415"}[chunkId] + ".js";
};